import { EventCardItem, VoucherCard, DonationsCard } from "components/index";
import flowRight from "lodash/flowRight";
import { makeSelectEvents } from "logic/events";
import { makeSelectCurOrg } from "logic/orgs";
import { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

class EventsListing extends Component {
  render() {
    const { org, events } = this.props;
    this.lastMonth = null;
    this.lastYear = null;

    return (
      <div className="event-cards">
        {events ? (
          events.map((event, index) => (
            <EventCardItem key={event.id} event={event} index={index} />
          ))
        ) : (
          <EventCardItem />
        )}
        {org &&
        org.portal &&
        org.portal.vouchers_enabled &&
        !process.env.HZL_INST ? (
          <VoucherCard />
        ) : null}
        {org && org.portal && org.portal.donations_enabled ? (
          <DonationsCard />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  events: makeSelectEvents(),
  org: makeSelectCurOrg(),
});

const enhance = flowRight(connect(mapStateToProps));

export default enhance(EventsListing);
